import { FormAreaTypesService } from './../../services/form.area.types.service';
import { Cd003CardIComponent } from './partialViews/cd003-card-I.component';
import { FormCd003 } from './../../entity/forms/form-cd003';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { CabecalhoDTO } from 'src/app/entity/dto/cabecalho.component';
import { EnumForm } from 'src/app/entity/enum/enum-form';
import { EnumFormType } from 'src/app/entity/enum/enum-form-type';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from 'src/app/services/notification.service';
import { Cd003CardIIComponent } from './partialViews/cd003-card-II.component';
import { Cd003CardIIIComponent } from './partialViews/cd003-card-III.component';
import { Cd003CardIVComponent } from './partialViews/cd003-card-IV.component';
import { Cd003CardVComponent } from './partialViews/cd003-card-V.component';
import { take } from 'rxjs/operators';
import { Cd003CardVIComponent } from './partialViews/cd003-card-VI.component';
import { Cd003CardVIIIComponent } from './partialViews/cd003-card-VIII.component';
import { Cd003CardVIIComponent } from './partialViews/cd003-card-VII.component';
import { Cd003CardIXComponent } from './partialViews/cd003-card-IX.component';
import { HttpErrorResponse } from '@angular/common/http';
import { Cd003CardGuideComponent } from './guideCard/cd003-card-guide.component';
import { MatDialog } from '@angular/material/dialog';
import { FormModalConfirmComponent } from 'src/app/shared/form-modal-confirm/form-modal-confirm.component';
import * as moment from 'moment';
import { ResumeAllFormsService } from 'src/app/services/resume-all-forms.service';
import { ParsedProperty } from '@angular/compiler';



@Component({
  selector: 'app-form-cd003',
  templateUrl: './form-cd003.component.html'
})

export class FormCd003Component implements OnInit, AfterViewInit {

  public header?: CabecalhoDTO;
  public formulario?: FormGroup;
  public btnCollapse?: boolean;
  public changeResult: boolean;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public enableButtons = this.loadingSubject.asObservable();
  public formCd003: FormCd003 = new FormCd003();
  public areaSelect: string = localStorage.getItem('area-select') || null
  public disabledBtnEditar: boolean = false;

  valuesInitial: any;
  valoresAlterados: any[] = [];
  currentUser: string = "";
  public changeFieldName = false;

  @ViewChild(Cd003CardIComponent, { static: false }) cd003CardIComponent: Cd003CardIComponent;
  @ViewChild(Cd003CardIIComponent, { static: false }) cd003CardIIComponent: Cd003CardIIComponent;
  @ViewChild(Cd003CardIIIComponent, { static: false }) cd003CardIIIComponent: Cd003CardIIIComponent;
  @ViewChild(Cd003CardIVComponent, { static: false }) cd003CardIVComponent: Cd003CardIVComponent;
  @ViewChild(Cd003CardVComponent, { static: false }) cd003CardVComponent: Cd003CardVComponent;
  @ViewChild(Cd003CardVIComponent, { static: false }) cd003CardVIComponent: Cd003CardVIComponent;
  @ViewChild(Cd003CardVIIComponent, { static: false }) cd003CardVIIComponent: Cd003CardVIIComponent;
  @ViewChild(Cd003CardVIIIComponent, { static: false }) cd003CardVIIIComponent: Cd003CardVIIIComponent;
  @ViewChild(Cd003CardIXComponent, { static: false }) cd003CardIXComponent: Cd003CardIXComponent;

  // tslint:disable-next-line: max-line-length
  constructor(
    protected formBuilder: FormBuilder,
    protected generalService: GeneralService,
    protected notificationService: NotificationService,
    protected formularioService: FormularioService,
    protected route: ActivatedRoute,
    protected resumeAllFormsService: ResumeAllFormsService,
    private cdr: ChangeDetectorRef,
    public dialog: MatDialog
  ) {
    this.header = new CabecalhoDTO();
    this.formulario = this.formCd003.CreateForm(formBuilder);
  }

  ngAfterViewInit(): void {
    this.route.data.subscribe(async (data: any) => {
      if (!!data) {
        this.valuesInitial = data?.formulario ?? this.formulario.getRawValue();;
        const type = (this.route?.snapshot?.params?.type);
        const isReadOnly: boolean = type === '2' ? true : false;
        this.loadingSubject.next(isReadOnly ? false : true);
        if (type === '1' || type === '2') {
          if (type === '1') {
            this.header = this.generalService.createHeader(EnumForm.FormCd003, EnumFormType.Edit);
          } else {
            this.header = this.generalService.createHeader(EnumForm.FormCd003, EnumFormType.Details);
          }
          await this.updateForm(data);
          await this.checkPTU();
        } else {

          this.header = this.generalService.createHeader(EnumForm.FormCd003, EnumFormType.New);
          await this.getUser();
          this.fillCreatedByFormField();
          this.cd003CardIComponent?.formulario.get('site_beneficiamento').setValue(this.generalService.getLocalStorageDataSite());
          await this.checkPTU();
        }
      }
    });
  }

  ngOnInit(): void {
    this.header = this.generalService.createHeader(EnumForm.FormCd003, EnumFormType.New);
    this.btnCollapse = true;
    this.loadingSubject.next(false);

  }

  async save(): Promise<void> {
    const id: number = this.formulario.get('id').value as number;
    const isAddFlow = id === 0;
    if (await this.validFormsToSave() !== '') {
      return
      // await this.formularioService.saveForm(id, this.formulario.getRawValue(), 'cd003', 'formcd003');
      // await this.openDialog();
    }
    await this.buildFormulario();
    await this.resumeAllFormsService.compareAdd(this.valuesInitial, this.formulario.getRawValue(), isAddFlow, 'cd003');
    await this.openConfirmDialog(this.resumeAllFormsService.valoresAlterados, isAddFlow);
  }

  public async openConfirmDialog(valoresAlterados: any[], isAddFlow): Promise<void> {
    const values: any[] = valoresAlterados;
    const dialogRef = this.dialog.open(FormModalConfirmComponent, {
      data: {
        valoresAlterados: values,
        isAddFlow
      }
    });
    dialogRef.afterClosed().subscribe(async x => {
      if (x.save) {
        const id: number = this.formulario.get('id').value as number;
        await this.formularioService.saveForm(id, this.formulario.getRawValue(), 'cd003', 'formcd003')
        await this.openDialog();


      } else {
        this.resumeAllFormsService.valoresAlterados = [];
      }
    })
  }



  async getForms(): Promise<FormGroup[]> {
    const arrForms: Array<FormGroup> = new Array<FormGroup>();
    arrForms.push(this.cd003CardIComponent?.formulario);
    arrForms.push(this.cd003CardIIComponent.formulario);
    arrForms.push(this.cd003CardIIIComponent.formulario);
    arrForms.push(this.cd003CardIVComponent.formulario);
    arrForms.push(this.cd003CardVComponent.formulario);
    arrForms.push(this.cd003CardVIComponent.formulario);
    arrForms.push(this.cd003CardVIIComponent.formulario);
    arrForms.push(this.cd003CardVIIIComponent.formulario);
    arrForms.push(this.cd003CardIXComponent.formulario);
    // if (this.areaSelect.includes('Básica')) {
    //   arrForms.push(this.Cd003CardIBasicComponent.formulario);
    //   arrForms.push(this.Cd003CardIIBasicComponent.formulario);
    //   arrForms.push(this.Cd003CardIIIBasicComponent.formulario);
    //   arrForms.push(this.Cd003CardIVBasicComponent.formulario);
    //   arrForms.push(this.Cd003CardVBasicComponent.formulario);
    //   arrForms.push(this.Cd003CardVIBasicComponent.formulario);
    //   arrForms.push(this.Cd003CardVIIBasicComponent.formulario);
    //   arrForms.push(this.Cd003CardVIIIBasicComponent.formulario);
    //   arrForms.push(this.Cd003CardIXBasicComponent.formulario);

    // } else {

    // }
    return await arrForms;
  }

  async setForms(arrForm: Array<FormGroup>) {
    ;
    this.cd003CardIComponent.formulario = arrForm[0];
    this.cd003CardIIComponent.formulario = arrForm[1];
    this.cd003CardIIIComponent.formulario = arrForm[2];
    this.cd003CardIVComponent.formulario = arrForm[3];
    this.cd003CardVComponent.formulario = arrForm[4];
    this.cd003CardVIComponent.formulario = arrForm[5];
    this.cd003CardVIIComponent.formulario = arrForm[6];
    this.cd003CardVIIIComponent.formulario = arrForm[7];
    this.cd003CardIXComponent.formulario = arrForm[8];
  }

  async validFormsToSave(): Promise<string> {
    return await this.formularioService.validForm(await this.getForms());
  }

  async cleanAll(): Promise<void> {
    if (this.header.ScreenType === this.generalService.getEnumFormType(
      EnumFormType.New)) {
      await this.formularioService.cleanForm(await this.getForms());
      await this.getUser();
      this.cd003CardIComponent?.formulario.get('site_beneficiamento').setValue(this.generalService.getLocalStorageDataSite());
    } else {
      const usuario: string = this.cd003CardIXComponent.formulario.get('usuario')?.value;
      await this.formularioService.cleanForm(await this.getForms());
      this.cd003CardIXComponent.formulario.get('usuario')?.setValue(usuario);
    }
  }

  async collapseAll(): Promise<void> {
    this.btnCollapse = this.btnCollapse ? false : true;
    this.cd003CardIComponent.collapseCard = this.btnCollapse ? false : true;
    this.cd003CardIIComponent.collapseCard = this.btnCollapse ? false : true;
    this.cd003CardIIIComponent.collapseCard = this.btnCollapse ? false : true;
    this.cd003CardIVComponent.collapseCard = this.btnCollapse ? false : true;
    this.cd003CardVComponent.collapseCard = this.btnCollapse ? false : true;
    this.cd003CardVIComponent.collapseCard = this.btnCollapse ? false : true;
    this.cd003CardVIIComponent.collapseCard = this.btnCollapse ? false : true;
    this.cd003CardVIIIComponent.collapseCard = this.btnCollapse ? false : true;
    this.cd003CardIXComponent.collapseCard = this.btnCollapse ? false : true;
  }

  public async buildFormulario(): Promise<void> {
    this.formulario = await this.formCd003.buildForm(this.formulario, await this.getForms(), this.generalService);
  }

  public async updateForm(data?: any): Promise<void> {
    this.formulario.get('id').setValue(data.formulario.id);
    await this.formCd003.updateForm(data, await this.getForms(), this.generalService);
  }

  private async getUser(): Promise<void> {
    await this.formularioService.getUser().pipe(take(1)).toPromise().then(response => {
      this.cd003CardIXComponent.formulario.get('usuario').setValue(response['user-profile']?.displayName ?? 'Administrador');
      this.currentUser = response['user-profile']?.displayName ?? 'Administrador';
    }).catch(async error => {
      await this.generalService.getUserNameValue().pipe(take(1)).toPromise().then((response: string) => {
        this.cd003CardIXComponent.formulario.get('usuario').setValue(response);
        this.currentUser = response;
      }).catch(err => {
      });
    });
  }

  private fillCreatedByFormField(): void {
    this.cd003CardIXComponent.formulario.get('criado_por').setValue(this.currentUser);
  }


  public async makeCalculations(event?: any): Promise<void> {
    await this.calcTotalDefeitos();
    await this.calcVazaoDescColunaAr();
    await this.calcVazaoDescDensimetrica();
    await this.calcPrcSemBoaDescColAr();
    await this.calcPrcDefBicaBoaColAr();
    await this.calcPrcSemBoaDescColSorter();
    await this.calcPrcDefBicaBoaColSorter();
    await this.calcPrcSemBoaDescDensimetrica();
    await this.calcDiferencaPesoHectoDensimetrica();
    await this.calcSemBoaDezSegundosG();
    await this.calcPerdaBoaPrc();
    await this.calcDefeitosPrc();
    await this.calcDescTotalPrc();
    await this.calcResDescrCasoReprovado();
    await this.calcResultado();
    await this.calcTotalDefeitosLeves();
    await this.calcTotalDefeitosSeveros();
    this.calcDifPesoHectolitrico();
  }

  public async mkCalcII($event?: any): Promise<void> {
    await this.calcVazaoSementeBoaColorSorter();
    await this.calcVazaoDescColorSorter()
  }
  public async makeEditBtn(event?: any): Promise<void> {
    await this.editBtn();
  }

  public async editBtn(): Promise<void> {
    this.cd003CardIVComponent.isPTU = true;
  }

  public async checkPTU(): Promise<void> {
    const siteRecebimento = this.cd003CardIComponent?.formulario.get('site_beneficiamento')?.value as string;
    if (siteRecebimento == 'PTU') {
      this.cd003CardIVComponent.isPTU = false;
      this.cd003CardIVComponent.hiddenButtonEditar = true;
    } else if (siteRecebimento !== 'PTU') {
      this.cd003CardIVComponent.isPTU = false;
    }
  }



  private async calcTotalDefeitos(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const quebradas: number = !!this.cd003CardIIIComponent.formulario.get('quebradas_g')?.value ? this.cd003CardIIIComponent.formulario.get('quebradas_g')?.value as number : 0;
    const quebradasSeveras: number = !!this.cd003CardIIIComponent.formulario.get('quebradas_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('quebradas_severas_g')?.value as number : 0;

    const ardidas: number = !!this.cd003CardIIIComponent.formulario.get('ardidas_g')?.value ? this.cd003CardIIIComponent.formulario.get('ardidas_g')?.value as number : 0;
    const ardidasSeveras: number = !!this.cd003CardIIIComponent.formulario.get('ardidas_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('ardidas_severas_g')?.value as number : 0;

    // tslint:disable-next-line: max-line-length
    const furadasLeves: number = !!this.cd003CardIIIComponent.formulario.get('furadas_leves_g')?.value ? this.cd003CardIIIComponent.formulario.get('furadas_leves_g')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    const furadasSeveras: number = !!this.cd003CardIIIComponent.formulario.get('furadas_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('furadas_severas_g')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    //const furadasRoedores: number = !!this.cd003CardIIIComponent.formulario.get('furadas_roedores_g')?.value ? this.cd003CardIIIComponent.formulario.get('furadas_roedores_g')?.value as number : 0;
    const silkCut: number = !!this.cd003CardIIIComponent.formulario.get('silk_cut_g')?.value ? this.cd003CardIIIComponent.formulario.get('silk_cut_g')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    const silkCutSeveras: number = !!this.cd003CardIIIComponent.formulario.get('silk_cut_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('silk_cut_severas_g')?.value as number : 0;

    const poppedKernel: number = !!this.cd003CardIIIComponent.formulario.get('popped_kernel_g')?.value ? this.cd003CardIIIComponent.formulario.get('popped_kernel_g')?.value as number : 0;
    const poppedKernelSeveras: number = !!this.cd003CardIIIComponent.formulario.get('popped_kernel_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('popped_kernel_severas_g')?.value as number : 0;

    const inerte: number = !!this.cd003CardIIIComponent.formulario.get('inerte_g')?.value ? this.cd003CardIIIComponent.formulario.get('inerte_g')?.value as number : 0;

    // tslint:disable-next-line: max-line-length
    const resultado: number = this.generalService.CalcPorc((quebradas + quebradasSeveras + ardidas + ardidasSeveras + furadasLeves + furadasSeveras + silkCut + silkCutSeveras + poppedKernel + poppedKernelSeveras), 100);
    this.cd003CardIIIComponent.formulario.get('total_defeitos_prc').setValue(resultado);
    this.cd003CardVIComponent.formulario.get('peso_g_defeitos_amostra_boa_cem_g_color_sorter').setValue(resultado);
  }

  private async calcTotalDefeitosLeves(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const quebradas: number = !!this.cd003CardIIIComponent.formulario.get('quebradas_g')?.value ? this.cd003CardIIIComponent.formulario.get('quebradas_g')?.value as number : 0;
    const ardidas: number = !!this.cd003CardIIIComponent.formulario.get('ardidas_g')?.value ? this.cd003CardIIIComponent.formulario.get('ardidas_g')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    const furadasLeves: number = !!this.cd003CardIIIComponent.formulario.get('furadas_leves_g')?.value ? this.cd003CardIIIComponent.formulario.get('furadas_leves_g')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    // tslint:disable-next-line: max-line-length
    //const furadasRoedores: number = !!this.cd003CardIIIComponent.formulario.get('furadas_roedores_g')?.value ? this.cd003CardIIIComponent.formulario.get('furadas_roedores_g')?.value as number : 0;
    const silkCut: number = !!this.cd003CardIIIComponent.formulario.get('silk_cut_g')?.value ? this.cd003CardIIIComponent.formulario.get('silk_cut_g')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    const poppedKernel: number = !!this.cd003CardIIIComponent.formulario.get('popped_kernel_g')?.value ? this.cd003CardIIIComponent.formulario.get('popped_kernel_g')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    const resultado: number = this.generalService.CalcPorc((quebradas + ardidas + furadasLeves + silkCut + poppedKernel), 100);
    this.cd003CardIIIComponent.formulario.get('total_defeitos_leves_prc').setValue(resultado);
  }

  private async calcTotalDefeitosSeveros(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const quebradasSeveras: number = !!this.cd003CardIIIComponent.formulario.get('quebradas_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('quebradas_severas_g')?.value as number : 0;
    const ardidasSeveras: number = !!this.cd003CardIIIComponent.formulario.get('ardidas_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('ardidas_severas_g')?.value as number : 0;
    const furadasSeveras: number = !!this.cd003CardIIIComponent.formulario.get('furadas_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('furadas_severas_g')?.value as number : 0;
    const silkCutSeveras: number = !!this.cd003CardIIIComponent.formulario.get('silk_cut_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('silk_cut_severas_g')?.value as number : 0;
    const poppedKernelSeveras: number = !!this.cd003CardIIIComponent.formulario.get('popped_kernel_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('popped_kernel_severas_g')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    const resultado: number = this.generalService.CalcPorc((quebradasSeveras + ardidasSeveras + furadasSeveras + silkCutSeveras + poppedKernelSeveras), 100);
    this.cd003CardIIIComponent.formulario.get('total_defeitos_severos_prc').setValue(resultado);
  }

  private async calcVazaoSementeBoaColorSorter(): Promise<void> {
    if (!this.areaSelect.includes('Básica')) {
      const medidor = this.cd003CardIVComponent.formulario.get('medidor_vazao')?.value?.trim()?.toUpperCase();
      if (medidor === 'SIM') {
        return;
      }
      const pesoGSementeBoaDezSegundos: number = !!this.cd003CardIVComponent.formulario.get('peso_g_semente_boa_dez_segundos')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_semente_boa_dez_segundos')?.value as number : 0;

      const resultado: number = (pesoGSementeBoaDezSegundos * 0.00036);
      this.cd003CardIVComponent.formulario.get('vazao_semente_boa_color_sorter_ton_h').setValue(resultado);
    }
    else {
      const pesoGSementeBoaDezSegundos: number = !!this.cd003CardIVComponent.formulario.get('peso_g_semente_boa_cinco_segundos')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_semente_boa_cinco_segundos')?.value as number : 0;
      const resultado: number = ((pesoGSementeBoaDezSegundos) * 0.00072);

      this.cd003CardIVComponent.formulario.get('vazao_semente_boa_color_sorter_ton_h').setValue(resultado);
    }
  }

  private async calcVazaoDescColunaAr(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    if (!this.areaSelect.includes('Básica')) {
      const pesoGDescDezSegColAr: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_coluna_ar')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_coluna_ar')?.value as number : 0;
      this.cd003CardIVComponent.formulario.get('vazao_descarte_coluna_ar_kg_h').setValue((pesoGDescDezSegColAr * 0.36));
    } else {
      const pesoGDescSesSegColAr: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_sessenta_segundos_coluna_ar')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_sessenta_segundos_coluna_ar')?.value as number : 0;
      const pesoGDescSesSegColAr2: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_sessenta_segundos_coluna_ar2')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_sessenta_segundos_coluna_ar2')?.value as number : 0;

      this.cd003CardIVComponent.formulario.get('vazao_descarte_coluna_ar_kg_h').setValue(((pesoGDescSesSegColAr + pesoGDescSesSegColAr2) * 2.16));

    }
  }

  private async calcVazaoDescColorSorter(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    if (!this.areaSelect.includes('Básica')) {
      const pesoGDescDezSegColSorter: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_color_sorter')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_color_sorter')?.value as number : 0;
      this.cd003CardIVComponent.formulario.get('vazao_descarte_color_sorter_kg_h').setValue((pesoGDescDezSegColSorter * 0.36));
    } else {


      const pesoGDescSesSegColSorter: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_sessenta_segundos_color_sorter')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_sessenta_segundos_color_sorter')?.value as number : 0;
      this.cd003CardIVComponent.formulario.get('vazao_descarte_color_sorter_kg_h').setValue(((pesoGDescSesSegColSorter) * 2.16));

    }
  }

  private async calcVazaoDescDensimetrica(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const pesoGDescDezSegDensi: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_densimetrica')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_densimetrica')?.value as number : 0;
    this.cd003CardIVComponent.formulario.get('vazao_descarte_densimetrica_kg_h').setValue((pesoGDescDezSegDensi * 0.36));
  }

  private async calcPrcSemBoaDescColAr(): Promise<void> {
    const pesoSemBoaAmoDescCemGColAr: number = !!this.cd003CardVComponent.formulario.get('peso_g_semente_boa_amostra_descarte_cem_g_coluna_ar')?.value ? this.cd003CardVComponent.formulario.get('peso_g_semente_boa_amostra_descarte_cem_g_coluna_ar')?.value as number : 0;
    this.cd003CardVComponent.formulario.get('prc_semente_boa_descarte_coluna_ar').setValue(this.generalService.CalcPorc(pesoSemBoaAmoDescCemGColAr, 100));
  }

  private async calcPrcDefBicaBoaColAr(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const pesoGDefAmoBoaCemGColAr: number = !!this.cd003CardVComponent.formulario.get('peso_g_defeitos_amostra_boa_cem_g_col_ar')?.value ? this.cd003CardVComponent.formulario.get('peso_g_defeitos_amostra_boa_cem_g_col_ar')?.value as number : 0;
    this.cd003CardVComponent.formulario.get('prc_defeitos_bica_boa_col_ar').setValue(this.generalService.CalcPorc(pesoGDefAmoBoaCemGColAr, 100));
  }

  private async calcPrcSemBoaDescColSorter(): Promise<void> {
    const pesoGSemBoaAmoDescCemGColSorter: number = !!this.cd003CardVIComponent.formulario.get('peso_g_semente_boa_amostra_descarte_cem_g_color_sorter')?.value ? this.cd003CardVIComponent.formulario.get('peso_g_semente_boa_amostra_descarte_cem_g_color_sorter')?.value as number : 0;
    this.cd003CardVIComponent.formulario.get('prc_semente_boa_descarte_color_sorter').setValue(this.generalService.CalcPorc(pesoGSemBoaAmoDescCemGColSorter, 100));
  }

  private async calcPrcDefBicaBoaColSorter(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const pesoGDefAmoBoaCemGColSorter: number = !!this.cd003CardVIComponent.formulario.get('peso_g_defeitos_amostra_boa_cem_g_color_sorter')?.value ? this.cd003CardVIComponent.formulario.get('peso_g_defeitos_amostra_boa_cem_g_color_sorter')?.value as number : 0;
    this.cd003CardVIComponent.formulario.get('prc_defeitos_bica_boa_color_sorter').setValue(this.generalService.CalcPorc(pesoGDefAmoBoaCemGColSorter, 100));
  }

  private async calcPrcSemBoaDescDensimetrica(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const pesoGDefAmoBoaCemGDensi: number = !!this.cd003CardVIIComponent.formulario.get('peso_g_semente_boa_amostra_descarte_cem_gramas_densimetrica')?.value ? this.cd003CardVIIComponent.formulario.get('peso_g_semente_boa_amostra_descarte_cem_gramas_densimetrica')?.value as number : 0;
    this.cd003CardVIIComponent.formulario.get('prc_semente_boa_descarte_densimetrica').setValue(this.generalService.CalcPorc(pesoGDefAmoBoaCemGDensi, 100));
  }

  private async calcDiferencaPesoHectoDensimetrica(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const pesoHectoFracaoBoaDensi: number = !!this.cd003CardVIIComponent.formulario.get('peso_hectolitrico_fracao_boa_densimetrica')?.value ? this.cd003CardVIIComponent.formulario.get('peso_hectolitrico_fracao_boa_densimetrica')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    const pesoHectoFracaoDescDensi: number = !!this.cd003CardVIIComponent.formulario.get('peso_hectolitrico_fracao_descarte_densimetrica')?.value ? this.cd003CardVIIComponent.formulario.get('peso_hectolitrico_fracao_descarte_densimetrica')?.value as number : 0;
    let resultado: number = (pesoHectoFracaoBoaDensi - pesoHectoFracaoDescDensi);
    if (pesoHectoFracaoBoaDensi > 0) {
      resultado = this.generalService.CalcPorc(resultado, pesoHectoFracaoBoaDensi);
    }
    this.cd003CardVIIComponent.formulario.get('diferenca_peso_hectolitrico_densimetrica').setValue(resultado);
  }

  private calcDifPesoHectolitrico(): void {
    const pesoHectolitricoBoa: number = !!this.cd003CardVComponent.formulario.get('peso_hectolitrico_fracao_boa_coluna_ar')?.value ? this.cd003CardVComponent.formulario.get('peso_hectolitrico_fracao_boa_coluna_ar')?.value as number : 0;
    const pesoHectolitricoDescarte: number = !!this.cd003CardVComponent.formulario.get('peso_hectolitrico_fracao_descarte_coluna_ar')?.value ? this.cd003CardVComponent.formulario.get('peso_hectolitrico_fracao_descarte_coluna_ar')?.value as number : 0;

    let resultado = pesoHectolitricoBoa - pesoHectolitricoDescarte;
    if (this.areaSelect.includes('Básica')) {
      if (pesoHectolitricoBoa > 0) {
        resultado = this.generalService.CalcPorc(resultado, pesoHectolitricoBoa);
      }
      this.cd003CardVComponent.formulario.get('diferenca_peso_hectolitrico_coluna_ar').setValue(resultado);
    }
  }

  private async calcPerdaBoaPrc(): Promise<void> {

    let resultado: number = 0;
    const medidor = this.cd003CardIVComponent.formulario.get('medidor_vazao')?.value?.trim()?.toUpperCase();

    const semBoaDezSegG: number = !!this.cd003CardVIIIComponent.formulario.get('semente_boa_dez_segundos_g')?.value ? this.cd003CardVIIIComponent.formulario.get('semente_boa_dez_segundos_g')?.value as number : 0;

    if (medidor === 'NÃO') {
      // tslint:disable-next-line: max-line-length
      const pesoGSemBoaDezSeg: number = !!this.cd003CardIVComponent.formulario.get('peso_g_semente_boa_dez_segundos')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_semente_boa_dez_segundos')?.value as number : 0;
      // tslint:disable-next-line: max-line-length
      const pesoGDescDezSegColAr: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_coluna_ar')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_coluna_ar')?.value as number : 0;
      // tslint:disable-next-line: max-line-length
      const pesoGDescDezSegColSorter: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_color_sorter')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_color_sorter')?.value as number : 0;
      const pesoGDescDezSegDensi: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_densimetrica')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_densimetrica')?.value as number : 0;
      if (semBoaDezSegG > 0) {
        resultado = this.generalService.CalcPorc(semBoaDezSegG, (pesoGSemBoaDezSeg + pesoGDescDezSegColAr + pesoGDescDezSegColSorter + pesoGDescDezSegDensi));
      }
    }
    else if (medidor === 'SIM') {
      const color_sorter_ton_h = this.cd003CardIVComponent.formulario.get('vazao_semente_boa_color_sorter_ton_h').value;
      const pesoGDescDezSegColAr: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_coluna_ar')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_coluna_ar')?.value as number : 0;
      const pesoGDescDezSegColSorter: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_color_sorter')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_color_sorter')?.value as number : 0;
      const pesoGDescDezSegDensi: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_densimetrica')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_densimetrica')?.value as number : 0;
      if (semBoaDezSegG > 0) {
        resultado = this.generalService.CalcPorc(semBoaDezSegG, ((color_sorter_ton_h / 0.00036) + pesoGDescDezSegColAr + pesoGDescDezSegColSorter + pesoGDescDezSegDensi));
      }
    }

    this.cd003CardVIIIComponent.formulario.get('perda_boa_prc').setValue(resultado);
  }

  private async calcDefeitosPrc(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const semBoaDezSegG: number = !!this.cd003CardVIIIComponent.formulario.get('semente_boa_dez_segundos_g')?.value ? this.cd003CardVIIIComponent.formulario.get('semente_boa_dez_segundos_g')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    const pesoGDescDezSegColAr: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_coluna_ar')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_coluna_ar')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    const pesoGDescDezSegColSorter: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_color_sorter')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_color_sorter')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    const pesoGDescDezSegDensi: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_densimetrica')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_densimetrica')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    const pesoGSemBoaDezSeg: number = !!this.cd003CardIVComponent.formulario.get('peso_g_semente_boa_dez_segundos')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_semente_boa_dez_segundos')?.value as number : 0;

    let resultado: number = 0;
    let divisor: number = 0
    const dividendo: number = (pesoGDescDezSegColAr + pesoGDescDezSegColSorter + pesoGDescDezSegDensi) - semBoaDezSegG;
    const medidor = this.cd003CardIVComponent.formulario.get('medidor_vazao')?.value?.trim()?.toUpperCase();
    if (medidor === 'SIM') {
      const color_sorter_ton_h = this.cd003CardIVComponent.formulario.get('vazao_semente_boa_color_sorter_ton_h').value;

      divisor = (color_sorter_ton_h / 0.00036) + pesoGDescDezSegColAr + pesoGDescDezSegColSorter;
    }
    else {
      divisor = pesoGSemBoaDezSeg + pesoGDescDezSegColAr + pesoGDescDezSegColSorter;
    }


    if (divisor > 0) {
      resultado = this.generalService.CalcPorc(dividendo, divisor);
    } else {
      resultado = dividendo;
    }

    this.cd003CardVIIIComponent.formulario.get('defeitos_prc').setValue(resultado);
  }

  private async calcDescTotalPrc(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const pesoGDescDezSegColAr: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_coluna_ar')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_coluna_ar')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    const pesoGDescDezSegColSorter: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_color_sorter')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_color_sorter')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    const pesoGDescDezSegDensi: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_densimetrica')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_densimetrica')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    const pesoGSemBoaDezSeg: number = !!this.cd003CardIVComponent.formulario.get('peso_g_semente_boa_dez_segundos')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_semente_boa_dez_segundos')?.value as number : 0;
    const medidor = this.cd003CardIVComponent.formulario.get('medidor_vazao')?.value?.trim()?.toUpperCase();

    const dividendo: number = pesoGDescDezSegColAr + pesoGDescDezSegColSorter + pesoGDescDezSegDensi;

    let divisor: number = 0;

    let resultado: number = 0;


    if (medidor === 'SIM') {
      const color_sorter_ton_h = this.cd003CardIVComponent.formulario.get('vazao_semente_boa_color_sorter_ton_h').value;

      divisor = (color_sorter_ton_h / 0.00036) + pesoGDescDezSegColAr + pesoGDescDezSegColSorter;
    }
    else {
      divisor = pesoGSemBoaDezSeg + pesoGDescDezSegColAr + pesoGDescDezSegColSorter;
    }

    if (divisor > 0) {
      resultado = this.generalService.CalcPorc(dividendo, divisor);
    } else {
      resultado = dividendo;
    }

    this.cd003CardVIIIComponent.formulario.get('descarte_total_prc').setValue(resultado);
  }

  private async calcSemBoaDezSegundosG(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    let pesoGSemBoaAmoDescCemGColAr: number = !!this.cd003CardVComponent.formulario.get('peso_g_semente_boa_amostra_descarte_cem_g_coluna_ar')?.value ? this.cd003CardVComponent.formulario.get('peso_g_semente_boa_amostra_descarte_cem_g_coluna_ar')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    let pesoGSemBoaAmoDescCemGColSorter: number = !!this.cd003CardVIComponent.formulario.get('peso_g_semente_boa_amostra_descarte_cem_g_color_sorter')?.value ? this.cd003CardVIComponent.formulario.get('peso_g_semente_boa_amostra_descarte_cem_g_color_sorter')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    let pesoGSemBoaAmoDescCemGDensi: number = !!this.cd003CardVIIComponent.formulario.get('peso_g_semente_boa_amostra_descarte_cem_gramas_densimetrica')?.value ? this.cd003CardVIIComponent.formulario.get('peso_g_semente_boa_amostra_descarte_cem_gramas_densimetrica')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    let pesoGDescDezSegColAr: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_coluna_ar')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_coluna_ar')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    let pesoGDescDezSegColSorter: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_color_sorter')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_color_sorter')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    let pesoGDescDezSegDensi: number = !!this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_densimetrica')?.value ? this.cd003CardIVComponent.formulario.get('peso_g_descarte_dez_segundos_densimetrica')?.value as number : 0;


    // tslint:disable-next-line: no-inferrable-types
    let resultado: number = 0;
    const dividendo: number = pesoGSemBoaAmoDescCemGColAr + pesoGSemBoaAmoDescCemGColSorter + pesoGSemBoaAmoDescCemGDensi;


    if (pesoGSemBoaAmoDescCemGColAr > 0) {
      pesoGSemBoaAmoDescCemGColAr = 1;
    }

    if (pesoGSemBoaAmoDescCemGColSorter > 0) {
      pesoGSemBoaAmoDescCemGColSorter = 1;
    }

    if (pesoGSemBoaAmoDescCemGDensi > 0) {
      pesoGSemBoaAmoDescCemGDensi = 1;
    }

    const divisor: number = (pesoGSemBoaAmoDescCemGColAr + pesoGSemBoaAmoDescCemGColSorter + pesoGSemBoaAmoDescCemGDensi) * 100;
    const multiplicador: number = pesoGDescDezSegColAr + pesoGDescDezSegColSorter + pesoGDescDezSegDensi;

    if (divisor > 0) {
      resultado = (dividendo / divisor) * multiplicador;
    } else {
      resultado = dividendo * multiplicador;
    }

    this.cd003CardVIIIComponent.formulario.get('semente_boa_dez_segundos_g').setValue(resultado);
  }

  private async calcResDescrCasoReprovado(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const quebradas: number = !!this.cd003CardIIIComponent.formulario.get('quebradas_g')?.value ? this.cd003CardIIIComponent.formulario.get('quebradas_g')?.value as number : 0;
    const quebradasSeveras: number = !!this.cd003CardIIIComponent.formulario.get('quebradas_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('quebradas_severas_g')?.value as number : 0;

    const ardidas: number = !!this.cd003CardIIIComponent.formulario.get('ardidas_g')?.value ? this.cd003CardIIIComponent.formulario.get('ardidas_g')?.value as number : 0;
    const ardidasSeveras: number = !!this.cd003CardIIIComponent.formulario.get('ardidas_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('ardidas_severas_g')?.value as number : 0;


    // tslint:disable-next-line: max-line-length
    const furadasLeves: number = !!this.cd003CardIIIComponent.formulario.get('furadas_leves_g')?.value ? this.cd003CardIIIComponent.formulario.get('furadas_leves_g')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    const furadasSeveras: number = !!this.cd003CardIIIComponent.formulario.get('furadas_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('furadas_severas_g')?.value as number : 0;
    // tslint:disable-next-line: max-line-length
    //const furadasRoedores: number = !!this.cd003CardIIIComponent.formulario.get('furadas_roedores_g')?.value ? this.cd003CardIIIComponent.formulario.get('furadas_roedores_g')?.value as number : 0;
    const silkCut: number = !!this.cd003CardIIIComponent.formulario.get('silk_cut_g')?.value ? this.cd003CardIIIComponent.formulario.get('silk_cut_g')?.value as number : 0;
    const silkCutSeveras: number = !!this.cd003CardIIIComponent.formulario.get('silk_cut_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('silk_cut_severas_g')?.value as number : 0;

    // tslint:disable-next-line: max-line-length

    const poppedKernel: number = !!this.cd003CardIIIComponent.formulario.get('popped_kernel_g')?.value ? this.cd003CardIIIComponent.formulario.get('popped_kernel_g')?.value as number : 0;
    const poppedKernelSeveras: number = !!this.cd003CardIIIComponent.formulario.get('popped_kernel_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('popped_kernel_severas_g')?.value as number : 0;
    // Pegar campo Hibrido e total defeitos!
    const hibrido: string = this.cd003CardIComponent?.formulario.get('hibrido_rnc')?.value ?? '';
    // tslint:disable-next-line: max-line-length
    const totalDefeitos: number = !!this.cd003CardIIIComponent.formulario.get('total_defeitos_prc')?.value ? this.cd003CardIIIComponent.formulario.get('total_defeitos_prc')?.value as number : 0;
    const inerte: number = !!this.cd003CardIIIComponent.formulario.get('inerte_g')?.value ? this.cd003CardIIIComponent.formulario.get('inerte_g')?.value as number : 0;
    const presencaSabugoPedunculo: string = this.cd003CardIIIComponent.formulario.get('presenca_sabugo_ou_pedunculo')?.value ?? 'Não';
    // tslint:disable-next-line: max-line-length
    const presencaOutrasSementesEspecies: string = this.cd003CardIIIComponent.formulario.get('presenca_outras_sementes_especies')?.value ?? 'Não';

    // tslint:disable-next-line: no-inferrable-types
    const arrResultado: string[] = [];
    // tslint:disable-next-line: no-inferrable-types
    let count: number = 0;

    //   if ((quebradas + quebradasSeveras) > 1.09) {
    //      arrResultado[count] = 'Rep. Quebradas';
    //      count++;
    //   }

    //  if ((ardidas + ardidasSeveras) > 1.59) {
    //     arrResultado[count] = 'Rep. Ardidas';
    //    count++;
    // }

    //  if ((furadasSeveras + furadasLeves) > 1.09) {
    //   arrResultado[count] = 'Rep. Furadas';
    //    count++;
    //  }

    //  if ((silkCut + silkCutSeveras) > 2.59) {
    //    arrResultado[count] = 'Rep. Silk Cut';
    //    count++;
    //   }

    //  if ((poppedKernel + poppedKernelSeveras) > 2.59) {
    //   arrResultado[count] = 'Rep. Popped Kernel';
    //   count++;
    //  }

    if (hibrido === 'AG1051' && totalDefeitos > 3) {
      arrResultado[count] = ' Hibrido AG1051 Rep. Total Defeitos';
      count++;
    }

    //  if (hibrido !== 'AG1051' && totalDefeitos > 2.5) {
    //    arrResultado[count] = 'Rep. Total Defeitos';
    //     count++;
    //  }

    if (inerte > 1.09) {
      arrResultado[count] = 'Rep. Materiais Inertes';
      count++;
    }

    if (presencaSabugoPedunculo?.toUpperCase() === 'SIM') {
      arrResultado[count] = 'Rep. sabugo/pedúnculo';
      count++;
    }

    if (presencaOutrasSementesEspecies?.toUpperCase() === 'SIM') {
      arrResultado[count] = 'Rep. outras espécies';
      count++;
    }

    if ((quebradas + ardidas + furadasLeves + poppedKernel + silkCut) > 3.59) {
      arrResultado[count] = 'Rep. Defeitos Leves';

      count++;

    }

    if ((ardidasSeveras + quebradasSeveras + furadasSeveras + poppedKernelSeveras + silkCutSeveras) > 1.50) {
      arrResultado[count] = 'Rep. Defeitos Severos';

      count++;

    }

    if ((quebradas + ardidas + furadasLeves + poppedKernel + silkCut + ardidasSeveras + quebradasSeveras + furadasSeveras + poppedKernelSeveras + silkCutSeveras) > 3.59) {
      arrResultado[count] = 'Rep. Total Defeitos';

      count++;

    }





    if (arrResultado?.length > 0) {
      this.cd003CardIIIComponent.formulario.get('resultado_descriminado_caso_reprovado').setValue(arrResultado.join(';').trim());
    } else {
      this.cd003CardIIIComponent.formulario.get('resultado_descriminado_caso_reprovado').setValue(arrResultado);
    }
  }

  private async calcResultado(): Promise<void> {
    // tslint:disable-next-line: max-line-length
    const quebradas: number = !!this.cd003CardIIIComponent.formulario.get('quebradas_g')?.value ? this.cd003CardIIIComponent.formulario.get('quebradas_g')?.value as number : 0;
    const quebradasSeveras: number = !!this.cd003CardIIIComponent.formulario.get('quebradas_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('quebradas_severas_g')?.value as number : 0;

    const ardidas: number = !!this.cd003CardIIIComponent.formulario.get('ardidas_g')?.value ? this.cd003CardIIIComponent.formulario.get('ardidas_g')?.value as number : 0;
    const ardidasSeveras: number = !!this.cd003CardIIIComponent.formulario.get('ardidas_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('ardidas_severas_g')?.value as number : 0;

    const furadasLeves: number = !!this.cd003CardIIIComponent.formulario.get('furadas_leves_g')?.value ? this.cd003CardIIIComponent.formulario.get('furadas_leves_g')?.value as number : 0;
    const furadasSeveras: number = !!this.cd003CardIIIComponent.formulario.get('furadas_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('furadas_severas_g')?.value as number : 0;

    const silkCut: number = !!this.cd003CardIIIComponent.formulario.get('silk_cut_g')?.value ? this.cd003CardIIIComponent.formulario.get('silk_cut_g')?.value as number : 0;
    const silkCutSeveras: number = !!this.cd003CardIIIComponent.formulario.get('silk_cut_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('silk_cut_severas_g')?.value as number : 0;


    const poppedKernel: number = !!this.cd003CardIIIComponent.formulario.get('popped_kernel_g')?.value ? this.cd003CardIIIComponent.formulario.get('popped_kernel_g')?.value as number : 0;
    const poppedKernelSeveras: number = !!this.cd003CardIIIComponent.formulario.get('popped_kernel_severas_g')?.value ? this.cd003CardIIIComponent.formulario.get('popped_kernel_severas_g')?.value as number : 0;

    const hibrido: string = this.cd003CardIComponent?.formulario.get('hibrido_rnc')?.value ?? '';
    const totalDefeitos: number = !!this.cd003CardIIIComponent.formulario.get('total_defeitos_prc')?.value ? this.cd003CardIIIComponent.formulario.get('total_defeitos_prc')?.value as number : 0;

    const inerte: number = !!this.cd003CardIIIComponent.formulario.get('inerte_g')?.value ? this.cd003CardIIIComponent.formulario.get('inerte_g')?.value as number : 0;
    const presencaSabugoPedunculo: string = this.cd003CardIIIComponent.formulario.get('presenca_sabugo_ou_pedunculo')?.value ?? 'Não';
    const presencaOutrasSementesEspecies: string = this.cd003CardIIIComponent.formulario.get('presenca_outras_sementes_especies')?.value ?? 'Não';

    // tslint:disable-next-line: no-inferrable-types
    let resultado: string = 'APR';

    if (!this.areaSelect.includes('Básica')) {
      console.log('ÁREA: COMERCIAL');

      if ((quebradas + ardidas + furadasLeves + poppedKernel + silkCut) > 4.09) {
        resultado = 'REP';
      }
      else if ((ardidasSeveras + quebradasSeveras + furadasSeveras + poppedKernelSeveras + silkCutSeveras) > 1.50) {
        resultado = 'REP';
      }
      else if ((quebradas + ardidas + furadasLeves + poppedKernel + silkCut + ardidasSeveras + quebradasSeveras + furadasSeveras + poppedKernelSeveras + silkCutSeveras) > 4.09) {
        resultado = 'REP';
      }
      else if (inerte > 1.09) {
        resultado = 'REP';
      }
      else if (presencaSabugoPedunculo?.toUpperCase() === 'SIM') {
        resultado = 'REP'
      }
      else if (presencaOutrasSementesEspecies?.toUpperCase() === 'SIM') {
        resultado = 'REP';
      }

      this.cd003CardIIIComponent.formulario.get('resultado').setValue(resultado);
      this.blockInputValuesApprove(resultado === 'APR' ? true : false)
    } else {
      console.log("ÁREA: BASICA")
      const somaLeves = quebradas + ardidas + furadasLeves + poppedKernel
      console.log(`SOMA LEVES: ${somaLeves}`)
      const somaSeveras = quebradasSeveras + ardidasSeveras + furadasSeveras + poppedKernelSeveras
      console.log(`SOMA SEVERAS: ${somaSeveras}`)
      const somaLevesSeveras = quebradas + ardidas + furadasLeves + poppedKernel + quebradasSeveras + ardidasSeveras + furadasSeveras + poppedKernelSeveras
      console.log(`SOMA LEVES SEVERAS: ${somaLevesSeveras}`)

      if (presencaSabugoPedunculo?.toUpperCase() === 'SIM' || presencaOutrasSementesEspecies?.toUpperCase() === 'SIM') {
        resultado = 'REP';
      }
      else if (somaLeves > 11 || somaSeveras > 3 || somaLevesSeveras > 14.00) {
        resultado = 'REP';
      }
      else if (somaLeves <= 7 && somaSeveras <= 3 && somaLevesSeveras <= 10) {
        resultado = 'APR';
      } else {
        resultado = 'ANR';
      }

      this.cd003CardIIIComponent.formulario.get('resultado').setValue(resultado);

    }

    //  if ((quebradas + quebradasSeveras) > 1.09) {
    //   resultado = 'REP';
    //  }

    ///  else if ((ardidas + ardidasSeveras) > 1.59) {
    //  resultado = 'REP';
    //  }

    //  else if ((furadasLeves + furadasSeveras) > 1.09) {
    //     resultado = 'REP';
    //  }

    // else if (hibrido === 'AG1051' && totalDefeitos > 3) {
    //    resultado = 'REP';
    //  }

    //  else if (hibrido !== 'AG1051' && totalDefeitos > 2.5) {
    //   resultado = 'REP';
    // }

    //  else if ((poppedKernel + poppedKernelSeveras) > 2.59) {
    //      resultado = 'REP';
    //  }

    //   else if ((silkCut + silkCutSeveras) > 2.59) {
    //    resultado = 'REP';
    //  }

  }

  public async getCd001Data(event?: any): Promise<void> {
    const loteCs = this.cd003CardIComponent?.formulario.get('lote_cs')?.value.toUpperCase() as string ?? '';
    await this.formularioService.getCd001DataFromLote(loteCs).pipe(take(1)).toPromise().then((objPc003: any) => {
      this.cd003CardIComponent?.formulario.get('site_beneficiamento').setValue(objPc003?.data?.site);
      this.cd003CardIComponent?.formulario.get('safra').setValue(objPc003?.data?.safra);
      this.cd003CardIComponent?.formulario.get('hibrido_rnc').setValue(objPc003?.data?.hibrido);
      this.cd003CardIComponent?.formulario.get('silo_origem').setValue(objPc003?.data?.destino);
      this.cd003CardIComponent?.formulario.get('peneira').setValue(objPc003?.data?.peneira);
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, `Ocorreu um erro ao buscar os dados correspondentes do CD001 a partir do lote ${loteCs}. O Lote CS existe na CD001?.`);
    });
  }

  async openDialog(): Promise<void> {
    const siteBeneficiamento = this.cd003CardIComponent?.formulario.get('site_beneficiamento')?.value;
    const safra = this.cd003CardIComponent?.formulario.get('safra')?.value;
    const equipamentosUtilizados = this.cd003CardIComponent?.formulario.get('equipamentos_utilizados')?.value;

    const controleAnalise = this.cd003CardIIComponent.formulario.get('controle_analise_ca')?.value;
    const numeroPassada: number = this.cd003CardIIComponent.formulario.get('previa_numero_passada')?.value as number;

    const quebradasLeves: number = this.cd003CardIIIComponent.formulario.get('quebradas_g')?.value as number;
    const quebradasSeveras: number = this.cd003CardIIIComponent.formulario.get('quebradas_severas_g')?.value as number;
    const ardidasLeves: number = this.cd003CardIIIComponent.formulario.get('ardidas_g')?.value as number;
    const ardidasSeveras: number = this.cd003CardIIIComponent.formulario.get('ardidas_severas_g')?.value as number;
    const furadasLeves: number = this.cd003CardIIIComponent.formulario.get('furadas_leves_g')?.value as number;
    const furadasSeveras: number = this.cd003CardIIIComponent.formulario.get('furadas_severas_g')?.value as number;
    const silkCutLeves: number = this.cd003CardIIIComponent.formulario.get('silk_cut_g')?.value as number;
    const silkCutSeveras: number = this.cd003CardIIIComponent.formulario.get('silk_cut_severas_g')?.value as number;
    const poppedKernelSeveras: number = this.cd003CardIIIComponent.formulario.get('popped_kernel_severas_g')?.value as number;
    const poppedKernelLeves: number = this.cd003CardIIIComponent.formulario.get('popped_kernel_g')?.value as number;
    const inertes: number = this.cd003CardIIIComponent.formulario.get('inerte_g')?.value as number;
    const sabugoPenduculo: number = this.cd003CardIIIComponent.formulario.get('presenca_sabugo_ou_pedunculo')?.value as number;
    const totalDefeitos: number = this.cd003CardIIIComponent.formulario.get('total_defeitos_prc')?.value as number;
    const resultado = this.cd003CardIIIComponent.formulario.get('resultado')?.value;
    const perdaBoaPrc = this.formulario.get('perda_boa_prc')?.value;

    const diferencaPesoHectolitrico: number = this.cd003CardVIIComponent.formulario.get('diferenca_peso_hectolitrico_densimetrica')?.value as number;
    const pesoHectolitricoFracaoBoa: number = this.cd003CardVIIComponent.formulario.get('peso_hectolitrico_fracao_boa_densimetrica')?.value as number;
    const id: number = this.formulario.get('id').value as number;

    if (numeroPassada != null
      && resultado != null
      && safra != null
      && controleAnalise != null
      && equipamentosUtilizados != null) {
      const dialogRef = this.dialog.open(Cd003CardGuideComponent, {
        width: '970px',
        maxHeight: '500px',
        data: {
          siteBeneficiamento: siteBeneficiamento,
          safra: safra,
          equipamentosUtilizados: equipamentosUtilizados,
          controleAnalise: controleAnalise,
          numeroPassada: numeroPassada,
          quebradasLeves: quebradasLeves,
          quebradasSeveras: quebradasSeveras,
          ardidasLeves: ardidasLeves,
          ardidasSeveras: ardidasSeveras,
          furadasLeves: furadasLeves,
          furadasSeveras: furadasSeveras,
          silkCutLeves: silkCutLeves,
          silkCutSeveras: silkCutSeveras,
          poppedKernelSeveras: poppedKernelSeveras,
          poppedKernelLeves: poppedKernelLeves,
          inerte: inertes,
          sabugoPenduculo: sabugoPenduculo,
          totalDefeitos: totalDefeitos,
          resultado: resultado,
          diferencaPesoHectolitrico: diferencaPesoHectolitrico,
          pesoHectolitricoFracaoBoa: pesoHectolitricoFracaoBoa,
          perdaBoaPrc: perdaBoaPrc,
          cd003Id: id
        },
      });
    }
  }

  private blockInputValuesApprove(resultado): void {
    if (this.areaSelect.includes('Básica')) {
      if (resultado) {
        this.cd003CardIXComponent.formulario.get('responsavel_autorizacao_especial').disable();
        this.cd003CardIXComponent.formulario.get('justificativa_aprovacao_especial').disable();
      } else {
        this.cd003CardIXComponent.formulario.get('responsavel_autorizacao_especial').enable();
        this.cd003CardIXComponent.formulario.get('justificativa_aprovacao_especial').enable();
      }
    }


  }

  async getDataQua007bySafra(data?: any) {
    await this.formularioService.getQua007Contrato(data).pipe(take(1)).toPromise().then((objQua007: any) => {
      this.cd003CardIComponent?.formulario.get('hibrido_rnc').setValue(objQua007?.data?.hibrido_rnc);
      this.cd003CardIComponent?.formulario.get('contrato_juridico').setValue(objQua007?.data?.contrato_juridico);
      // this.cd003CardIComponent?.formulario.get('prioridade').setValue(objQua007?.data?.jit);
      // this.cd003CardIComponent?.formulario.get('geracao').setValue(objQua007?.data?.geracao);



    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, `Ocorreu um erro, não foi possivel encontrar o valor de Hibrido ou Contrato Jurídico.`);
    });
  }

  changeNameByEquipament($event: any): void {
    const getValue = this.cd003CardIComponent.formulario.get('equipamentos_utilizados')?.value?.trim()?.toUpperCase();
    console.log(getValue)
    if (getValue === 'DENSIMÉTRICA') {
      this.changeFieldName = true;
    } else {
      this.changeFieldName = false
    }
  }

  async getPC003Data(data?: any) {
    await this.formularioService.getPc003Data(data.contratoJuridico, data.safra, data.numeroCampo).pipe(take(1)).toPromise().then((objPC003: any) => {
      this.cd003CardIComponent?.formulario.get('hibrido_rnc').setValue(objPC003?.data?.hibrido_rnc);
      this.cd003CardIComponent?.formulario.get('contrato_juridico').setValue(objPC003?.data?.contrato_juridico);
      this.cd003CardIComponent?.formulario.get('prioridade').setValue(objPC003?.data?.jit);
      this.cd003CardIComponent?.formulario.get('geracao').setValue(objPC003?.data?.geracao);

    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, `Ocorreu um erro, não foi possivel encontrar o valor de prioridade ou Geração.`);
    });
  }


  async getDadosMateriaPrima() {
    const siteBeneficiamento = this.cd003CardIComponent?.formulario.get('site_beneficiamento').value
    const controleAnalise = this.cd003CardIIComponent.formulario.get('controle_analise_ca').value
    const safra = this.cd003CardIComponent?.formulario.get('safra').value
    if (siteBeneficiamento !== null && controleAnalise !== null && safra) {
      await this.formularioService.getcd003Data(controleAnalise, siteBeneficiamento, safra).pipe(take(1)).toPromise().then((objcd003: any) => {
        if (objcd003?.data != null) {
          this.cd003CardIComponent?.formulario.get('lote_cs')?.setValue(objcd003?.data?.lote_cs);
          this.cd003CardIComponent?.formulario.get('lote_tb')?.setValue(objcd003?.data?.lote_tb);
          this.cd003CardIComponent?.formulario.get('hibrido_rnc')?.setValue(objcd003?.data?.hibrido_rnc);
          this.cd003CardIComponent?.formulario.get('peneira_basica')?.setValue(objcd003?.data?.peneira);
          this.cd003CardIComponent?.formulario.get('geracao')?.setValue(objcd003?.data?.geracao);
          this.cd003CardIComponent?.formulario.get('prioridade')?.setValue(objcd003?.data?.prioridade);
          this.cd003CardIComponent?.formulario.get('contrato_juridico')?.setValue(objcd003?.data?.contrato_juridico);
          this.cd003CardIComponent?.formulario.get('linha_processamento')?.setValue(objcd003?.data?.linha_processamento);
          this.cd003CardIComponent?.formulario.get('numero_campo')?.setValue(objcd003?.data?.numero_campo);
          this.cdr.detectChanges();
        }

      });
    }
  }
}
